import React from 'react'
import { useParams, Navigate } from 'react-router-dom'

import ArticlePageLayout from './ArticlePageLayout'
import { getPost } from './posts'

const BlogPostPage = () => {
  const { slug } = useParams<{ slug: string }>()
  const post = slug ? getPost(slug) : undefined

  if (!post) {
    return <Navigate to='/blog' replace />
  }

  const { title, date, image, Content, tableOfContents } = post
  const hasToc = Boolean(tableOfContents?.length)

  return (
    <ArticlePageLayout
      documentTitle={`${title} | TinyInvoice.app`}
      backTo='/blog'
      backLabel='← Back to blog'
      title={title}
      date={date}
      image={image}
      tableOfContents={hasToc ? tableOfContents : undefined}
    >
      <Content />
    </ArticlePageLayout>
  )
}

export default BlogPostPage
